module.exports = __webpack_public_path__ + "img/banner_lyq.915265ac.jpg";